// Others
import { urlApiConversation } from '~/utils/constants/apis';
import axiosClient, { CustomAxiosRequestConfig } from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IQueryParamBase } from '~/utils/interface/common';
import {
  IConversation,
  ICreateMessageRes,
  IMessageByConversation,
  INewConversation,
  IQueryCreateNewConversation,
  IQueryCreateNewMessage,
  IQueryGetListMessage,
} from '~/utils/interface/conversation';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const conversationApi = {
  getListConversation: (params: IQueryParamBase) => {
    const url = urlApiConversation.getListConversation;
    return axiosClient.get<IBaseResponse<IListDataResponse<IConversation[]>>>(url, { params });
  },

  createNewMessage: ({ conversationId, formData }: IQueryCreateNewMessage) => {
    const url = urlApiConversation.createNewMessage(conversationId);
    return axiosClient.post<IBaseResponse<ICreateMessageRes>>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
      skipToast: true,
    } as CustomAxiosRequestConfig);
  },

  createNewConversation: (body: IQueryCreateNewConversation) => {
    const url = urlApiConversation.createNewConversation;
    return axiosClient.post<IBaseResponse<INewConversation>>(url, body, {
      skipToast: true,
    } as CustomAxiosRequestConfig);
  },

  getListMessage: ({ conversationId, params }: IQueryGetListMessage) => {
    const url = urlApiConversation.getListMessage(conversationId);
    return axiosClient.get<IBaseResponse<IMessageByConversation>>(url, { params });
  },
};

export default conversationApi;
